export default "__VITE_ASSET__7f60cc5a__"